'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _provinces = require('../../helpers/provinces');

var _translate = require('../../language/translate');

var _commonFunctions = require('../../helpers/commonFunctions');

var _url = require('../../../util/url');

var _url2 = _interopRequireDefault(_url);

var _ActionCreators = require('../../actions/ActionCreators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContactForm = function (_Component) {
  _inherits(ContactForm, _Component);

  function ContactForm(props) {
    _classCallCheck(this, ContactForm);

    var _this = _possibleConstructorReturn(this, (ContactForm.__proto__ || Object.getPrototypeOf(ContactForm)).call(this, props));

    _this.getErrorMessage = function () {
      var _this$state = _this.state,
          selectedProvince = _this$state.selectedProvince,
          firstName = _this$state.firstName,
          lastName = _this$state.lastName,
          email = _this$state.email,
          notes = _this$state.notes;

      var errorMessage = !selectedProvince || !firstName || !lastName || !email || !notes ? (0, _translate.t)('Please select a province and enter your first name, last name, email address, and notes') : '';

      _this.setState({ errorMessage: errorMessage });
      return errorMessage;
    };

    _this.resetForm = function () {
      _this.firstNameInput.value = '';
      _this.lastNameInput.value = '';
      _this.emailInput.value = '';
      _this.phoneInput.value = '';
      _this.notesInput.value = '';
      _this.setState({
        selectedProvince: '',
        firstName: '',
        lastName: '',
        email: '',
        notes: '',
        phone: '',
        successMessage: (0, _translate.t)('Thank you,') + ' ' + (_this.state.firstName && ' ' + _this.state.firstName + '!') + ',  ' + (0, _translate.t)('We’ll get back to you within one business day!')
      });
      _this.props.resetContactForm();
    };

    _this.toggleForm = function () {
      _this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      });
    };

    _this.state = {
      isOpen: false,
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      notes: '',
      selectedProvince: '',
      errorMessage: null,
      successMessage: null
    };
    return _this;
  }

  _createClass(ContactForm, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.formSubmitted) {
        this.resetForm();
      }
    }
  }, {
    key: 'submitForm',
    value: function submitForm() {
      var data = {
        first_name: this.state.firstName,
        last_name: this.state.lastName,
        email: this.state.email,
        phone: this.state.phone,
        notes: this.state.notes,
        province: this.state.selectedProvince,
        product_url: window.location.href,
        tracking_code: (0, _url2.default)('tracking_code', null)
      };

      this.setState({ successMessage: null });

      if (!this.getErrorMessage()) {
        (0, _commonFunctions.submitFormDetails)(this, data);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var provinceOptions = (0, _provinces.provinces)();
      return _react2.default.createElement(
        'div',
        {
          className: 'contact-form-container ' + (this.state.isOpen ? 'open' : '')
        },
        _react2.default.createElement(
          'div',
          { className: 'contact-toggle', onClick: this.toggleForm },
          _react2.default.createElement(
            'h5',
            { className: 'toggle-text' },
            (0, _translate.t)('Contact a Representative')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'contact-form' },
          _react2.default.createElement(
            'h4',
            { className: 'contact-title' },
            (0, _translate.t)('Contact Us if you require Assistance')
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              (0, _translate.t)('What province are you currently in?')
            )
          ),
          _react2.default.createElement(
            'select',
            {
              value: this.state.selectedProvince,
              onChange: function onChange(e) {
                return _this2.setState({ selectedProvince: e.target.value });
              },
              ref: function ref(_ref) {
                _this2.provinceInput = _ref;
              }
            },
            _react2.default.createElement(
              'option',
              { key: -1, disabled: true, value: '' },
              '---'
            ),
            provinceOptions.map(function (province, i) {
              return _react2.default.createElement(
                'option',
                { key: i, value: province.value },
                (0, _translate.t)(province.text)
              );
            })
          ),
          _react2.default.createElement(
            'h5',
            null,
            (0, _translate.t)('Please contact us for assistance or submit a request and a representative will get back to you.')
          ),
          _react2.default.createElement(
            'p',
            null,
            (0, _translate.t)('Note: Quebec applicants will be contacted by a representative before further steps.')
          ),
          _react2.default.createElement(
            'div',
            { className: 'text-fields' },
            _react2.default.createElement('input', {
              type: 'text',
              onChange: function onChange(e) {
                return _this2.setState({ firstName: e.target.value });
              },
              placeholder: (0, _translate.t)('First Name'),
              ref: function ref(_ref2) {
                _this2.firstNameInput = _ref2;
              }
            }),
            _react2.default.createElement('input', {
              type: 'text',
              onChange: function onChange(e) {
                return _this2.setState({ lastName: e.target.value });
              },
              placeholder: (0, _translate.t)('Last Name'),
              ref: function ref(_ref3) {
                _this2.lastNameInput = _ref3;
              }
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'text-fields' },
            _react2.default.createElement('input', {
              type: 'email',
              onChange: function onChange(e) {
                return _this2.setState({ email: e.target.value });
              },
              placeholder: (0, _translate.t)('Email Address'),
              ref: function ref(_ref4) {
                _this2.emailInput = _ref4;
              }
            }),
            _react2.default.createElement('input', {
              type: 'tel',
              onChange: function onChange(e) {
                return _this2.setState({ phone: e.target.value });
              },
              placeholder: (0, _translate.t)('Phone Number'),
              ref: function ref(_ref5) {
                _this2.phoneInput = _ref5;
              }
            })
          ),
          _react2.default.createElement('textarea', {
            onChange: function onChange(e) {
              return _this2.setState({ notes: e.target.value });
            },
            placeholder: (0, _translate.t)('Notes'),
            ref: function ref(_ref6) {
              _this2.notesInput = _ref6;
            }
          }),
          _react2.default.createElement(
            'div',
            { className: 'div-center padding-topbottom-10' },
            _react2.default.createElement(
              'button',
              {
                className: 'button btn btn-primary',
                onClick: this.submitForm.bind(this)
              },
              (0, _translate.t)('Submit')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'disclaimer-alert' },
            this.state.errorMessage
          ),
          this.state.successMessage && _react2.default.createElement(
            'div',
            { className: 'form-success' },
            this.state.successMessage
          )
        )
      );
    }
  }]);

  return ContactForm;
}(_react.Component);

ContactForm.propTypes = {
  auth: _react2.default.PropTypes.object,
  fields: _react2.default.PropTypes.object,
  error: _react2.default.PropTypes.object,
  formSubmitted: _react2.default.PropTypes.bool,
  resetContactForm: _react2.default.PropTypes.func
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.api.authorization,
    error: state.application.contactForm.error,
    formSubmitted: state.application.contactForm.formSubmitted
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    resetContactForm: function resetContactForm() {
      return dispatch((0, _ActionCreators.resetContactForm)());
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContactForm);


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/ContactUs.jsx
// module id = 1663
// module chunks = 0